/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Injectable} from '@angular/core';
import {NEVER, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';

import {REQUEST_OPTIONS} from '../../../app.constants';
import {ApiService} from '../../api';


/**
 * Variable zones that are showed in a generated form.
 */
@Injectable()
export class VariableZoneService {

  constructor(private api: ApiService) {
  }

  public getRepVariableZones(cliRegId: number, name: string, isEss: boolean = false) {
    return this.api.config
      .get(`/cliReg/${cliRegId}/repVariableZones/${name}?isEss=${isEss}`, REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        switchMap((response) => {
          if (response.status === 204) {
            return NEVER;
          }
          return of(response.body);
        })
      );
  }

}
